import {call} from 'redux-saga/effects';

import {
    loadInitialLive,
    loadLiveUpdate,
    loadInitialTimetable,
    loadTimetableUpdate,
    loadBalance,
    loadFreebet,
    loadBetsStatus,
    loadStakesStatus,
    loadCashoutsStatus
} from '../sagas';

export default function *rootSaga() {
    yield [
        call(loadInitialLive),
        call(loadLiveUpdate),
        call(loadInitialTimetable),
        call(loadTimetableUpdate),
        call(loadBalance),
        call(loadFreebet),
        call(loadBetsStatus),
        call(loadStakesStatus),
        call(loadCashoutsStatus)
    ];
}



// WEBPACK FOOTER //
// ./js/sport-betting/rootSaga.js